module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3a7GcZQf3k86NkOrlEak0N-272882ff1d1611585ca04ddfee16f4fa.jpg";